<template>
  <div class="w-full">
    <section
      v-if="totalTopics === 0 && !$route.query.title"
      class="flex justify-center w-full"
    >
      <img
        src="@/assets/images/empty.svg"
        alt="empty topics"
        class="w-[90vw] md:w-[37vw]"
      />
    </section>
    <section
      v-else-if="$route.query.title && totalTopics === 0"
      class="flex flex-col items-center justify-center w-full mt-14"
    >
      <img
        src="@/assets/images/result-empty.svg"
        alt="empty results"
        class="w-[37vw] md:w-[8vw] min-w-[136px]"
      />
      <span
        class="w-[80vw] md:w-full text-center text-base gap-2 flex flex-col mt-4 text-h-neutral-700 justify-center items-center"
      >
        <p class="font-extrabold">
          {{ $t("labels.generic", { pt: "Sem resultados", en: "No results" }) }}
        </p>
        <p class="font-semibold">
          {{
            $t("labels.generic", {
              pt: "Não foram encontrados tópicos com o termo pesquisado.",
              en: "No topics were found with the search term.",
            })
          }}
        </p>
      </span>
      <button
        class="border btn-outline min-w-[143px] rounded font-bold h-8 w-[39vw] md:w-[9.9vw] mt-6 cursor-pointer flex items-center justify-center text-base mb-32"
        @click="clearFilter"
      >
        {{
          $t("labels.generic", { pt: "Limpar pesquisa", en: "Clean search" })
        }}
      </button>
    </section>
    <section
      v-else
      class="sm:w-[90vw] md:w-full sm:max-w-[640px] md:max-w-[100vw] flex flex-col items-center"
    >
      <TopicCard v-for="topic in topics" :topic="topic" class="mx-4 mb-6" />
      <Paginator
        :totalRecords="totalTopics"
        :rows="numberOfTopicsPerPage"
        :value="topics"
        :first="getFirstItemIndexActualPage()"
        @page="onPaginate"
        :pageLinkSize="3"
        class="mb-16 md:w-full w-fit md:flex md:right-0 md:justify-end custom-paginator-forum"
      ></Paginator>
    </section>
  </div>
</template>
<script lang="ts">
import { Topic } from "@/models/topic.model";
import { QueryParams } from "@/models/query-params.model";
import { PageState } from "primevue/paginator";
const TopicCard = defineAsyncComponent(
  () => import("./TopicCard/topic-card.vue")
);
import { defineComponent, defineAsyncComponent, PropType } from "vue";
export default defineComponent({
  name: "list-table",
  components: {
    TopicCard,
  },
  props: {
    topics: {
      type: Array as PropType<Topic[]>,
      required: true,
      default: [],
    },
    totalTopics: {
      type: Number,
      required: true,
      default: 0,
    },
    numberOfTopicsPerPage: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  data() {
    return {
      query: new QueryParams(),
    };
  },
  methods: {
    onPaginate(event: PageState): void {
      this.query.page = event.page;
      this.$emit("paginate", this.query);
    },
    getFirstItemIndexActualPage(): number | undefined {
      if (this.$route.query.page) {
        return (
          Number(this.$route.query.page) * Number(this.numberOfTopicsPerPage) +
          1
        );
      }
    },
    clearFilter(): void {
      this.$emit("clearFilter", { page :0 , title: "" });
    },
  },
});
</script>
